import App from './App'
import router from './router'
import store from './store'
import Vue from 'vue'
import { query } from '@didi/public-sdk'
import './cube-ui'
import { getAuthStatus, getUserInfo } from './api'
import tool from 'common-js/util/tool'
import pageInit from 'common-js/api/pageInit'
import { initHttp } from 'common-js/api/http'
import VDOMPurify from 'common-js/directives/v-dompurify-html.js'

initHttp({
  bizId: 'b8bcd9fe1862486e67ff53177e615d1a',
  appVer: '1.0.0',
  domainList: ['ucenter.diditaxi.com.cn', 'ucenterpre.diditaxi.com.cn']
})

Vue.use(VDOMPurify)

const urlParams = query.resolveQuery()
// const lang = (urlParams.lang && urlParams.lang.toLocaleLowerCase()) || 'zh-cn'

// let localMap = {
//   'zh-cn': 'zh-CN',
//   'en-us': 'en-US'
// }
// const langMap = localMap[lang]
// TODO 优化
window.GlobalSet = {
  query: {
    ...urlParams
  }
}

// eslint-disable-next-line no-undef
pageInit().then(async () => {
  const vm = new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
  })
  tool.dynamicSetFontSize()
  tool.whiteScreenMonitorChange()
	// TODO loading
  await getUserInfo(vm)
	await getAuthStatus(vm)
})
